import API_ROUTES from "../config/apiRoutes";

/** Create a new place
 * @param data - request body
 * @param t - translation function
 */
export async function createNewPlace(data: any, t: any) {
  const response = await fetch(API_ROUTES.place.create, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) throw new Error(t("api.error.post"));
  return response.json();
}

/** Get all places
 * @param t - translation function
 */
export async function getAllPlaces(t: any, getImgs = false) {
  const path: string = !getImgs
    ? API_ROUTES.place.getAll
    : API_ROUTES.place.getAllWithImages;

  const response = await fetch(path);
  if (!response.ok) throw new Error(t("api.error.get"));
  return response.json();
}

/**
 * Get newest 10 places
 * @param t - translation function
 */
export async function getNewestPlaces(t: any) {
  const response = await fetch(API_ROUTES.place.getNewest);
  if (!response.ok) throw new Error(t("api.error.get"));
  return response.json();
}

/** Get place by ID
 * @param id - place UUID
 * @param t - translation function
 */
export async function getPlaceById(id: string, t: any) {
  const response = await fetch(API_ROUTES.place.getById(id));
  if (!response.ok) throw new Error(t("api.error.get"));
  return response.json();
}

/** Update a place by ID
 * @param id - place UUID
 * @param data - request body
 * @param t - translation function
 */
export async function updatePlace(id: string, data: any, t: any) {
  const response = await fetch(API_ROUTES.place.update(id), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) throw new Error(t("api.error.put"));
  return response.json();
}

/** Delete a place by ID (requires token in body)
 * @param id - place UUID
 * @param data - request body with token
 * @param t - translation function
 */
export async function deletePlace(id: string, data: any, t: any) {
  const response = await fetch(`${API_ROUTES.place.delete}?id=${id}`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) throw new Error(t("api.error.delete"));
  return response.status === 204 ? null : response.json();
}
